import Path from "../../services/paths";
import CategoryActions from "../actions/categoryActions";
import utils from "../common/utils";

class CategoryMiddleware {
  static getCategory() {
    return dispatch => {
      dispatch(CategoryActions.categoryRequest());
      utils
        .get_token()
        .then(token => {
          fetch(Path.GET_CATEGORY, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => res.json())
            .then(res => {
              if (res.error) {

              } else {
                if (
                  res.detail === "Authentication credentials were not provided."
                ) {
                  localStorage.clear();
                  window.location.reload();
                }
                dispatch(CategoryActions.categorySuccessul(res));
              }
            })
            .catch(error => {
              dispatch(CategoryActions.categoryFailed(error));
            });
        })
        .catch(error => {
          dispatch(CategoryActions.categoryFailed(error));
        });
    };
  }
}

export default CategoryMiddleware;
